// src/components/Dashboard/TechnicianOptusReturnedStockDetailTable.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Order from '../Order/Order';
import { Heading, LoadingSpinner, LoadingContainer, DetailContainer, CloseButton, DetailTable, DetailHeader, DetailRow, DetailData, ModalOverlay, ModalContent } from '../../styled/common';

const TechnicianOptusReturnedStockDetailTable = ({ user, material, tech, onClose }) => {
  const [optusReturnedStockData, setOptusReturnedStockData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // Step 1: Track if modal is open
  const [selectedOrderNo, setSelectedOrderNo] = useState(null); // Step 1: Track selected order number

  useEffect(() => {
    const fetchOptusReturnedStockData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await axios.get(`/api/inventory?material=${material}&tech_id=${tech}`);
        const inventoryData = response.data;
        const totalOptusReturnedStock = inventoryData[0].totalOptusReturnedStock;

        if (totalOptusReturnedStock > 0) {
          const actions = inventoryData[0].actions || {};
          const filteredKeys = Object.keys(actions).filter((key) => actions[key][4] > 0);

          if (filteredKeys.length > 0) {
            const detailResponse = await axios.get('/api/salesorders', { params: { ids: filteredKeys.join(',') } });
            const salesOrders = detailResponse.data;

            const mergedData = filteredKeys.map((key) => {
              const salesOrder = salesOrders.find((order) => order._id === key);
              return {
                ...salesOrder,
                optusReturnedStockQuantity: actions[key][4],
              };
            });

            setOptusReturnedStockData(mergedData);
          } else {
            setOptusReturnedStockData([]);
          }
        } else {
          setOptusReturnedStockData([]);
        }
      } catch (error) {
        setError('Failed to fetch data. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptusReturnedStockData();
  }, [material, tech]);

  const handleOrderClick = (orderNo) => {
    setSelectedOrderNo(orderNo); // Set the selected order number
    setIsModalOpen(true); // Open the modal
  };

  const handleCloseDetail = () => {
    setIsModalOpen(false); // Close the modal
    setSelectedOrderNo(null); // Clear the selected order number
  };

  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingSpinner />
      </LoadingContainer>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <DetailContainer>
      <CloseButton onClick={onClose}>Close</CloseButton>
      <Heading>Optus Returned Stock Analysis</Heading>
      <DetailTable>
        <thead>
          <tr>
            <DetailHeader>Material</DetailHeader>
            <DetailHeader>Material Description</DetailHeader>
            <DetailHeader>Associated Order</DetailHeader>
            <DetailHeader>Associated NMO</DetailHeader>
            <DetailHeader>Returned Stock Quantity</DetailHeader>
            <DetailHeader>Last Updated</DetailHeader>
          </tr>
        </thead>
        <tbody>
          {optusReturnedStockData.map((item) => (
            <DetailRow key={item._id}>
              <DetailData data-label="Material">{item.Material}</DetailData>
              <DetailData data-label="Material Description">{item['Material Description']}</DetailData>
              <DetailData
                data-label="Associated Order"
                onClick={() => handleOrderClick(item['PO Number'].split('-')[1])}
                isClickable={true}
              >
                {item['PO Number'].split('-')[1]}
              </DetailData>
              <DetailData data-label="Associated NMO">{item['Sales Order']}</DetailData>
              <DetailData data-label="Returned Stock Quantity">{item.optusReturnedStockQuantity}</DetailData>
              <DetailData data-label="Last Updated">{new Date(item.updatedAt).toLocaleString()}</DetailData>
            </DetailRow>
          ))}
        </tbody>
      </DetailTable>

      {isModalOpen && (
        <ModalOverlay>
          <ModalContent>
            <CloseButton onClick={handleCloseDetail}>Close</CloseButton> {/* Step 4: Add close button */}
            {/* Pass selectedOrderNo to the Order component */}
            <Order propOrderNo={selectedOrderNo} user={user}/>
          </ModalContent>
        </ModalOverlay>
      )}
      
    </DetailContainer>
  );
};

export default TechnicianOptusReturnedStockDetailTable;
